import {mapActions, mapGetters} from 'vuex'

export const tagMixin = {
  computed: {
    ...mapGetters({
      'tags': 'tags/all'
    })
  },
  methods: {
    ...mapActions({
      'getTags': 'tags/getTags',
      'getAllTagsCreative': 'tags/getAllTagsCreative',
      'getTag': 'tags/getTag',
      'deleteTag': 'tags/deleteTag',
      'refreshTag': 'tags/refreshTag',
      'updateTag': 'tags/updateTag'
    })
  }
}



// WEBPACK FOOTER //
// ./src/mixins/tagMixin.js